module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 8-0e0092ad963fad70c2ad4ebb2bcb989f.webp";